import { AppStore } from './lib/AppStore';

// --

const store = new AppStore();
export default store;